import { Injector, Component, OnInit, HostBinding, ViewChildren, AfterViewInit } from '@angular/core';
import { EventsComponent } from '../events/events.component';
import * as bowser from 'bowser';

@Component({
	selector: 'info-block',
	templateUrl: './info-block.component.html',
	styleUrls: ['info-block.component.scss'],
})
export class InfoBlockComponent extends EventsComponent implements OnInit, AfterViewInit {
	reorgenizeCoverages: boolean;
	toggleShowInfoBlocks: boolean;
	insurerHasPackages: boolean;
	viewValue: any;
	isCovModFlagOn: boolean = false;
	isCustomizable: boolean = false;
	isAgentflowType: boolean;
	selectedPackageType: string;
	isEditMode: boolean = false;

	@HostBinding('class.coverage-package')
	isCoveragePackage: boolean;

	@ViewChildren('covrageElem')
	covrageElem;

	CoveragesOptions;
	showTitle = false;
	// coveragesAdded: boolean;
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';

		const globalAttributes = this.storeService.getGlobalAttributes();
		if (globalAttributes) {
			this.reorgenizeCoverages = globalAttributes['reorgenizeCoverages'];
			this.isCovModFlagOn = globalAttributes['covModFlag'];
		}

		this.layoutService.globalAttributes.subscribe((data) => {
			this.isAgentflowType = data['flowType'] == 'Agent';
			this.toggleShowInfoBlocks = data['showInfoBlocks'];
		});

		this.layoutService.staticLayout.subscribe((data) => {
			if (data && data.data.metadata.page.stage == 'YourRates') {
				if (this.isCovModFlagOn) {
					this.selectedPackageType = data.data.answers.page['CarrierInformation'].packageType
						? data.data.answers.page['CarrierInformation'].packageType
						: this.selectedPackageType;

					this.isCustomizable = data.data.answers.page['CarrierInformation'].isCustomizable;

					this.isEditMode = this.carrierInformationService.isEditMode;

					if (this.control.controlName) {
						if (this.control.controlName == 'CoverageInfo')
							this.control = data.data.metadata.page.controls.find((item) => item.controlName == 'CoverageInfo');
						if (this.control.controlName == 'ClaimInfo')
							this.control = data.data.metadata.page.controls.find((item) => item.controlName == 'ClaimInfo');
						if (this.control.controlName == 'AdditionalInfo') {
							this.control = data.data.metadata.page.controls.find((item) => item.controlName == 'AdditionalInfo');
							if (this.selectedPackageType == 'Custom') this.showTitle = true;
						}
					}

					this.GetCoveragesOptions();
					this.setpackageCoverage(this.selectedPackageType);
				}
			}
		});

		var carrierInformation = this.storeService.getValue('CarrierInformation', this.context);

		this.isCustomizable = carrierInformation.isCustomizable;

		this.control.attributes.isCoveragePackage = this.isCoveragePackage = this.control.attributes.isCoveragePackage;

		this.GetCoveragesOptions();

		this.observablesService.insurerSelected.subscribe(() => {
			this.GetCoveragesOptions();
		});

		this.observablesService.packageSelected.subscribe((packagetype: string) => {
			this.setpackageCoverage(packagetype);
			this.selectedPackageType = packagetype;
		});
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
		setTimeout(() => {
			this.evaluteShowTitle();
		}, 1);
	}

	setDropdownValue(value) {
		this.viewValue = value;

		return this.viewValue;
	}

	getHelpTitle(title) {
		return `HelpPopup.${title.replace(/ /g, '')}`;
	}

	getSelectedPackage() {
		return this.storeService.getValue('CarrierInformation', this.context);
	}

	// user changed package
	setpackageCoverage(packageType: string) {
		// No package covrages
		if (!this.CoveragesOptions) {
			return false;
		}

		// get the amounts
		const temp = this.CoveragesOptions.packageCoverages
			? this.CoveragesOptions.packageCoverages.filter((item) => item.packageType === packageType)
			: null;

		if (!temp || temp.length === 0) {
			return;
		}

		// update the amounts
		if (this.CoveragesOptions.coverages)
			this.CoveragesOptions.coverages.forEach((item, index) => (item.amount = temp[0].results[index]));
		else if (this.CoveragesOptions.coveragesGroups) {
			var index = this.isAgentflowType ? 1 : 0;
			this.CoveragesOptions.coveragesGroups.forEach((cvgGroup) =>
				cvgGroup.coverages.forEach((item) => {
					item.amount = temp[0].results[index];
					index++;
				})
			);
		}
		setTimeout(() => {
			this.evaluteShowTitle();
		}, 1);
	}

	// user changed carrier
	GetCoveragesOptions() {
		const selected = this.getSelectedPackage();
		this.insurerHasPackages = selected.hasPackage;

		if (selected === undefined || selected.name === undefined || selected.name === false) {
			this.CoveragesOptions = [];
		} else {
			const list = this.control.attributes.options.filter((item) => item.name === selected.name)[0];
			this.CoveragesOptions = list ? list.options[0] : [];

			if (!this.CoveragesOptions.packageCoverages || this.CoveragesOptions.packageCoverages.length === 0) {
				this.toggleInfoBlock('none');
			}
		}

		if (selected.name === 'Foremost') {
			let roofCoverage =
				this.CoveragesOptions &&
				this.CoveragesOptions.coverages &&
				this.CoveragesOptions.coverages.find((item) => item.title.startsWith('Settlement option - Roof'));

			if (roofCoverage) {
				roofCoverage.title = 'Settlement Option - Roof';
			}
		}
	}

	// Highlight the covrage entire row
	shouldHighlightRow(info) {
		const selected = this.getSelectedPackage();
		const packageType = selected && selected.packageType ? selected.packageType : this.selectedPackageType;
		// Check if the highlightDifferentValue/visibleAndHighlightNew array contain the selected packageType then return true/false
		if (info && packageType) {
			if (info.visibleAndHighlightNew) {
				return info.visibleAndHighlightNew.indexOf(packageType) > -1;
			} else if (info.highlightDifferentValue) {
				return info.highlightDifferentValue.indexOf(packageType) > -1;
			}
		}

		return false;
	}

	// Highlight the covrage entire Group
	shouldHighlightGroup(group) {
		var highlight = false;
		const selected = this.getSelectedPackage();
		const packageType = selected && selected.packageType ? selected.packageType : this.selectedPackageType;
		// Check if the highlightDifferentValue/visibleAndHighlightNew array contain the selected packageType then return true/false
		group.coverages.forEach((cover: any) => {
			if (cover && packageType) {
				if (cover.visibleAndHighlightNew) {
					highlight = cover.visibleAndHighlightNew.indexOf(packageType) > -1;
					return;
				} else if (cover.highlightDifferentValue) {
					highlight = cover.highlightDifferentValue.indexOf(packageType) > -1;
					return;
				}
			}
		});

		return highlight;
	}

	// toggle view the covrage
	shouldShowCovrage(info) {
		const selected = this.getSelectedPackage();

		if (!info) {
			this.toggleInfoBlock('none');
			return false;
		} else if (info && !info.visibleAndHighlightNew) {
			// the visibleAndHighlightNew not set then should show this covrage for all
			this.toggleInfoBlock('inline-block');
			return true;
		} else if (
			selected &&
			(info.visibleAndHighlightNew.indexOf(selected.packageType || this.selectedPackageType || 'Popular') > -1 ||
				this.selectedPackageType == 'Custom')
		) {
			// the selected packageType is in the info visibleAndHighlightPackages attribute
			this.toggleInfoBlock('inline-block');
			return true;
		} else {
			this.toggleInfoBlock('none');
			return false;
		}
	}

	toggleInfoBlock(val: string) {
		// let elem = this.elementRef.nativeElement.closest(".control-container");
		const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement;
		this.Renderer.setStyle(elem, 'display', val);
		this.Renderer.setStyle(elem, 'margin-bottom', '35px');
	}

	shouldShowTitle() {
		return this.showTitle;
	}

	evaluteShowTitle() {
		this.showTitle = this.covrageElem.length > 0 ? true : false;
	}
}
